import { Theme } from '@emotion/react';

declare module '@emotion/react' {
  export interface Theme {
    colors: {
      primary100: string;
      primary300: string;
      primary400: string;
      primary500: string;
      primary600: string;
      primary700: string;
      primary800: string;
      primary900: string;
      primary920: string;
      primary950: string;

      secondary500: string;
      secondary600: string;
      mapBackground: string;

      gray500: string;

      primaryContrast500: string;
      primaryContrast300: string;
    };

    gradients: {
      primaryLinearGradient: string;
      modal: string;
      rankingCard: string;
    };

    profile: {
      textColor: string;
      activeColor: string;
      disabledColor: string;
      hoverColor: string;
    },

    progress: {
      gradient: string;
      gradientLight: string;
    },

    select: {
      arrowColor: string;
      background: string;
      border: string;
      dropdownBackground: string;
      dropdownActiveBackground: string;
      textColor: string;
    },

    status: {
      danger: string;
      warning: string;
    },

    main: {
      background: string;
    },

    virtualScrollBarColor: string,

    profileWidth: number;
    profileBackgroundColor: string;

    loginFooterHeight: number;
  }
}

export const theme: Theme = {
  profileWidth: 25 * 16,
  profileBackgroundColor: '#1d2a52e6',

  loginFooterHeight: 90,

  gradients: {
    primaryLinearGradient: 'linear-gradient(135deg, rgba(2,41,99,1) 8%, rgba(4,6,56,1) 75%)',
    modal: 'linear-gradient(330deg, rgba(4,6,55,1) 28%, rgba(9,72,131,1) 100%)',
    rankingCard: 'linear-gradient(153deg, #00aaf5 0%, #024e8c 33%, #030538 100%)',
  },

  profile: {
    textColor: '#FFF',
    activeColor: '#01a4ef',
    disabledColor: '#727c9a',
    hoverColor: '#03366f',
  },

  progress: {
    gradient: 'linear-gradient(266deg, #030538 0%, #00AAF5 100%)',
    gradientLight: 'linear-gradient(266deg, #00AAF5 0%, #030538 100%)',
  },

  select: {
    arrowColor: '#01a4ef',
    background: '#080938',
    border: '#00beb9',
    dropdownBackground: '#080938',
    dropdownActiveBackground: '#01a4ef',
    textColor: '#FFF',
  },

  status: {
    danger: '#ff4040',
    warning: 'yellow',
  },

  main: {
    background: 'linear-gradient(175deg, #00aaf5 0, #03184e 46%, #030538 100%) 0 0',
  },

  virtualScrollBarColor: 'rgba(255, 255, 255, 0.5)',

  colors: {
    primary100: '#FFF',
    primary300: '#919198',
    primary400: '#73738c',
    primary500: '#48C2DC',
    primary600: '#505058',
    primary700: '#00a3e5',
    primary800: '#21212b',
    primary900: '#022963',
    primary920: '#252A95 ',
    primary950: '#080938',
    secondary500: '#00a3e5',
    secondary600: '#305f88',
    gray500: '#73738c',
    mapBackground: '#0968ca',
    primaryContrast500: '#FFF',
    primaryContrast300: '#818DAA',
  },
};
